import request from "@/utils/request";
const areaId = sessionStorage.getItem('CURRENTCITYCODE') || 62;

// 获取字典
export const getSelectDic = (params) => {
  return request({
    url: '/api/system/dic/selectDicAll',
    method: 'post',
    params
  })
}

// 地图
export const getMapData = (params) => {
  return request({
    url: '/api/system/govCockpit/overview/district/page',
    method: 'get',
    params
  });
}

// 获取总览
export const getTotalOverview = (params) => {
  return request({
    url: '/api/system/govCockpit/overview/district/operational',
    method: 'get',
    params
  });
}

// 市州融资放款情况
export const getDistrictDemandAndDrawingData = (params) => {
  return request({
    url: '/api/system/govCockpit/overview/districtDemandAndDrawing',
    method: 'get',
    params
  })
}

//公司名获取企业信息
export const getCompanyInfoByName = (params) => {
  return request({
    url: '/api/system/comyCertification/selectBasicInfo',
    method: 'post',
    params
  });
}

//关键词检索企业列表
export const getCompanyListByKey = (params) => {
  return request({
    url: '/api/system/comBasicInfo/entList',
    method: 'get',
    params
  });
}

//上传文件
export const uploadFile = (params,type) => {
  return request({
    url: '/api/system/comyCertification/fileupload?filetype='+type,
    method: 'post',
    data:params
  });
}

//企业提交认证信息
export const submitAuth = (params) => {
  return request({
    url: '/api/system/comyCertification/companyAuthSubmit',
    method: 'post',
    params
  });
}

//企业授权
export const eSignAuth = () => {
  return request({
    url: '/api/system/eSign/task/createWithFile',
    method: 'post',
  });
}

//企业签署授权书
export const eSignPdfFile = () => {
  return request({
    url: '/api/system/eSign/task/orgSignByPdfFile',
    method: 'post',
  });
}

// 获取成功申请信息
export const getIndexDrawList = () => {
  const params = { areaId };
  return request({
    url: '/api/system/statsDemandAmountComplete/getindexDrawList',
    method: 'post',
    params
  })
}

// 获取成功申请信息
export const selectBasicInfoNew = (params) => {
  return request({
    url: '/api/system/comyCertification/selectBasicInfoNew',
    method: 'post',
    params
  })
}

// 上传
export const upload = (params) => {
  return request({
    url: '/api/system/pub/file/upload',
    method: 'post',
    data:params
  })
}

// 获取电子营业执照文件路径
export const getFileAndUpload = (params) => {
  return request({
    url: '/api/system/comyCertification/getFileAndUpload',
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/interfaceAPI/common.js